// 智慧报修类别
const repairLMJurisdiction = [
  { id: "011001001", label: "添加报修类别", children: [] },
  { id: "011001002", label: "修改报修类别", children: [] },
  { id: "011001003", label: "删除报修类别", children: [] }
];

// 维修工管理
const repairPersonManageJurisdiction = [
  { id: "011004001", label: "添加", children: [] },
  { id: "011004002", label: "修改", children: [] },
  { id: "011004003", label: "删除", children: [] }
];

// 报修记录
const repairRecordJurisdiction = [
  { id: "011002001", label: "导出", children: [] }
];

// 缴费记录
const repairPayRecordJurisdiction = [
  { id: "011003001", label: "导出", children: [] }
];

// 智慧报修
const repairJurisdictionChildren = [
  {
    id: "011006000",
    label: "概览",
    routerName: "repair-over-view",
    children: []
  },
  {
    id: "011001000",
    label: "报修类别",
    routerName: "repair-category-manage",
    children: repairLMJurisdiction
  },
  {
    id: "011004000",
    label: "维修工管理",
    routerName: "repair-person-manage",
    children: repairPersonManageJurisdiction
  },
  {
    id: "011002000",
    label: "报修记录",
    routerName: "repair-record",
    children: repairRecordJurisdiction
  },
  {
    id: "011003000",
    label: "缴费记录",
    routerName: "repair-pay-record",
    children: repairPayRecordJurisdiction
  },
  {
    id: "011005000",
    label: "操作日志",
    routerName: "repair-manage-log",
    children: []
  }
];

const repairJurisdiction = {
  id: "011",
  label: "智慧报修",
  children: repairJurisdictionChildren
};

export { repairJurisdiction };



// WEBPACK FOOTER //
// ./src/utils/jurisdiction/repairJurisdiction.js